/* InputText.tsx
   Version: 1.0.1
   Date: 2020-12-12
*/

// eslint-disable-next-line
import React from 'react';
import PropTypes from 'prop-types';

export interface InputTextProps {
    className?: string;
    name: string;
    value: string;
    index?: number;
    rowindex?: number;
    colindex?: number;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    refFunc?: (input: HTMLInputElement) => void;
    placeholder?: string;
}

const InputText: React.FC<InputTextProps> = (props): JSX.Element => {

    InputText.propTypes = {
        className: PropTypes.string,
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        index: PropTypes.number,
        rowindex: PropTypes.number,
        colindex: PropTypes.number,
        onChange: PropTypes.func.isRequired,
        onKeyPress: PropTypes.func,
        refFunc: PropTypes.func,
        placeholder: PropTypes.string,
    }

    return (
        <input 
            className={props.className ?? 'basic-inputtext'} 
            type='text' 
            data-name={props.name} 
            data-index={props.index}
            data-rowindex={props.rowindex}
            data-colindex={props.colindex}
            value={props.value} 
            onChange={props.onChange} 
            ref={props.refFunc} 
            onKeyPress={props.onKeyPress} 
            placeholder={props.placeholder}
            />
    );

}

export default InputText;
